import {
  AlertDialogContent as AlertDialogContentPrimitive,
  type ModalContentProps
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export function AlertDialogContent(props: ModalContentProps): ReactNode {
  return (
    <AlertDialogContentPrimitive
      py="space_unit.x1"
      borderRadius="radii.x4"
      {...props}
    />
  );
}
